// ═══════════════════════════════════════════════════════════════
// HOOK GENÉRICO DE DATOS DE REPORTE
// Archivo: hooks/useReportData.js
// ═══════════════════════════════════════════════════════════════

import { useState, useCallback } from 'react';
import { getReportData, exportReportExcel, exportReportPDF, exportReportCSV } from '../../../../api/payrollReports';

export default function useReportData(reportType) {
  const [data,     setData]     = useState([]);
  const [summary,  setSummary]  = useState(null);
  const [columns,  setColumns]  = useState([]);
  const [metadata, setMetadata] = useState(null);
  const [loading,  setLoading]  = useState(false);
  const [exporting,setExporting]= useState(null); // 'excel'|'pdf'|'csv'|null
  const [error,    setError]    = useState(null);
  const [hasData,  setHasData]  = useState(false);

  const fetchReport = useCallback(async (filters) => {
    if (!filters.companyId) return;
    try {
      setLoading(true);
      setError(null);
      const result = await getReportData(reportType, filters);
      if (result.success) {
        setData(result.data     || []);
        setSummary(result.summary || null);
        setColumns(result.columns || []);
        setMetadata(result.metadata || null);
        setHasData(true);
      }
    } catch (err) {
      console.error(`Error cargando reporte ${reportType}:`, err);
      setError(err.response?.data?.error || 'Error al cargar el reporte');
    } finally {
      setLoading(false);
    }
  }, [reportType]);

  const exportExcel = useCallback(async (filters) => {
    try {
      setExporting('excel');
      await exportReportExcel(reportType, filters);
    } catch (err) {
      setError('Error al exportar Excel');
    } finally {
      setExporting(null);
    }
  }, [reportType]);

  const exportPDF = useCallback(async (filters) => {
    try {
      setExporting('pdf');
      await exportReportPDF(reportType, filters);
    } catch (err) {
      setError('Error al exportar PDF');
    } finally {
      setExporting(null);
    }
  }, [reportType]);

  const exportCSV = useCallback(async (filters) => {
    try {
      setExporting('csv');
      await exportReportCSV(reportType, filters);
    } catch (err) {
      setError('Error al exportar CSV');
    } finally {
      setExporting(null);
    }
  }, [reportType]);

  return {
    data, summary, columns, metadata,
    loading, exporting, error, hasData,
    fetchReport, exportExcel, exportPDF, exportCSV,
  };
}
